import styles from "./FilterBar.module.css";

interface FilterBarProps {
  categories: string[];
  activeCategories: string[];
  onCategoryToggle: (category: string) => void;
  /** Optional fixed label width so "Category:" aligns with sibling filter rows. */
  labelMinWidth?: string;
}

export default function FilterBar({ categories, activeCategories, onCategoryToggle, labelMinWidth }: FilterBarProps) {
  if (categories.length === 0) return null;

  return (
    <div className={styles.filterRow} role="group" aria-label="Filter by category">
      {/* eslint-disable-next-line react/forbid-dom-props -- minWidth is a prop-driven value, not a static style */}
      <span className={styles.filterLabel} style={labelMinWidth ? { minWidth: labelMinWidth } : undefined}>Category:</span>
      {categories.map((cat) => {
        const active = activeCategories.some((c) => c.toLowerCase() === cat.toLowerCase());
        return (
          <button
            key={cat}
            onClick={() => onCategoryToggle(cat)}
            className={`${styles.categoryPill}${active ? ` ${styles.categoryPillActive}` : ""}`}
            type="button"
            aria-pressed={active}
          >
            {cat}
          </button>
        );
      })}
    </div>
  );
}
